import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookie from 'js-cookie';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../_metronic';
import HeaderDropdownToggle from '../content/CustomDropdowns/HeaderDropdownToggle';
import { permissionTypes } from '../../../utils';
import '../../../_metronic/_assets/sass/custom/header.scss';
import { set } from 'lodash';
import {
  changeSelectedOrg,
  changeSelectedRole,
  clearPermissions,
  clearSelectedPermission,
  getAllPermissions,
} from '../../store/action/PermissionAction';
import { SET_PERMISSION_CLEAR } from '../../store/types';

const UserProfile = (showHi, showAvatar, showBadge) => {
  // let [permissionTemp, setPermissionTemp] = useState({org: null, role: null});
  const dispatch = useDispatch();
  // internal state to show modal
  const [show, setShow] = useState(false);

  const [showBtn, setShowBtn] = useState(false);

  let [orgDropdownDisabled, setOrgDropdownDisabled] = useState(false);

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  let [roleList, setRoleList] = useState([]);
  let [currentRole, setCurrentRole] = useState();
  let [currentOrg, setCurrentOrg] = useState();

  let location = useLocation();
  let params = new URLSearchParams(location.search);
  let organizationKeyParam;
  if (params.get('organization-key')) {
    organizationKeyParam = params.get('organization-key');
  }

  const history = useHistory();

  const userInfo = JSON.parse(
    Cookie.get('edx-user-info')
      .replace(/\\054/g, ',')
      .replace(/\\/g, '')
  );
  // const {instructor} = permissionTypes;
  // const roles = permission.roles;
  //
  // const history = useHistory();
  // const dispatch = useDispatch();

  function handleSelectOrg(value) {
    // setPermissionTemp(newValue);
    setRoleList(value.roles);
    // setCurrentRole(value.roles)
    value.roles[0] ? setCurrentRole(value.roles[0]) : setCurrentRole(null);
    setCurrentOrg(value.organization);
  }

  function handleSelectRole(value) {
    setCurrentRole(value);
    // let newValue = {role: value, org: permissionTemp.org};
    // setPermissionTemp(newValue);
  }

  const handleShow = () => setShow(true);

  function handleClose() {
    dispatch(changeSelectedOrg(currentOrg));
    dispatch(changeSelectedRole(currentRole));
    setShow(false);

    history.push('/');

    // window.location.reload(false);
    // localStorage.setItem("permission", JSON.stringify(permissionTemp));
    // window.location.reload();
  }

  useEffect(() => {
    if ((selectedRole === null || selectedOrg === null) && selectionOptionCount() >= 1) {
      setShow(true);
    }
  }, [selectedOrg, selectedRole]);

  function selectionOptionCount() {
    let count = 0;
    permissions.forEach(item => {
      count += item.roles.length;
    });

    return count;
  }

  useEffect(() => {
    // LS => local storage
    // let permissionLS = JSON.parse(localStorage.getItem("permission"));
    // if (permissionLS) {
    //   setPermissionTemp(permissionLS);
    //   setShowBtn(true);
    // } else {
    //   if (convertedPermissions?.length == 0) {
    //     setShowBtn(false);
    //     setShow(false);
    //   } else if (
    //     convertedPermissions?.length == 1 &&
    //     convertedPermissions[0].roles?.length == 1
    //   ) {
    //     let newValue = {
    //       org: convertedPermissions[0],
    //       role: convertedPermissions[0].roles[0],
    //     };
    //     console.log("test");
    //     localStorage.setItem("permission", JSON.stringify(newValue));
    //     setPermissionTemp(newValue);
    //     setShowBtn(false);
    //     setShow(false);
    //   } else if (convertedPermissions?.length > 1) {
    //     setShowBtn(true);
    //     setShow(true);
    //   }
    // }
    setShowBtn(selectionOptionCount() > 1);
  }, []);

  function selectionOptionCount() {
    let count = 0;
    permissions.forEach(item => {
      count += item.roles.length;
    });

    return count;
  }

  useEffect(() => {
    // LS => local storage
    // let permissionLS = JSON.parse(localStorage.getItem("permission"));
    // if (permissionLS) {
    //   setPermissionTemp(permissionLS);
    //   setShowBtn(true);
    // } else {
    //   if (convertedPermissions?.length == 0) {
    //     setShowBtn(false);
    //     setShow(false);
    //   } else if (
    //     convertedPermissions?.length == 1 &&
    //     convertedPermissions[0].roles?.length == 1
    //   ) {
    //     let newValue = {
    //       org: convertedPermissions[0],
    //       role: convertedPermissions[0].roles[0],
    //     };
    //     console.log("test");
    //     localStorage.setItem("permission", JSON.stringify(newValue));
    //     setPermissionTemp(newValue);
    //     setShowBtn(false);
    //     setShow(false);
    //   } else if (convertedPermissions?.length > 1) {
    //     setShowBtn(true);
    //     setShow(true);
    //   }
    // }
    setShowBtn(selectionOptionCount() > 1);
  }, []);

  useEffect(() => {
    if (organizationKeyParam) {
      // if (convertedPermissions) {
      //   convertedPermissions.forEach((item) => {
      //     if (item.organization.organization_key === organizationKeyParam) {
      //       let newValue = {org: item, role: null};
      //       setPermission(newValue);
      //       setPermissionTemp(newValue);
      //       setOrgDropdownDisabled(true);
      //     }
      //   });
      // }
    }
  }, [permissions]);

  function logoutClickHandler() {
    localStorage.clear('persist:root');

    Cookie.remove('edx-user-info');
    Cookie.remove('edx-jwt-cookie');
    Cookie.remove('edxloggedin');
    Cookie.remove('sessionid');

    setTimeout(function() {
      dispatch(clearSelectedPermission());

      dispatch(clearPermissions());

      window.location.replace(process.env.REACT_APP_MARKETING_URL + `/user/before-logout`);
    }, 1);
  }

  useEffect(function() {
    dispatch(getAllPermissions());
  }, []);
  return (
    <>
      <div className={'config-dropdown'}>
        {showBtn && (
          <button className={'btn text-primary'} onClick={handleShow}>
            <i class="fas fa-edit" />
            تغییر نقش
          </button>
        )}
        {selectionOptionCount() >= 1 && (
          <span>
            شما با سازمان <span style={{ fontWeight: '900' }}>{selectedOrg?.name}</span> و نقش{' '}
            <span style={{ fontWeight: '900' }}>{selectedRole?.translated_name}</span> وارد شده‌اید.
          </span>
        )}

        <Modal
          show={show}
          onHide={() => {
            setShow(false);
          }}
          keyboard={false}
          animation={true}
        >
          <Modal.Header>
            <Modal.Title>لطفا سازمان و نقش خود را تعیین کنید</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col xs={6}>
                  <DropdownButton
                    disabled={orgDropdownDisabled}
                    variant={'secondary'}
                    menualign={'right'}
                    title={currentOrg?.name ? currentOrg?.name : 'انتخاب سازمان'}
                  >
                    {permissions &&
                      permissions.map(function(item) {
                        return (
                          <Dropdown.Item key={item.organization.id} onSelect={() => handleSelectOrg(item)}>
                            {item.organization.name}
                          </Dropdown.Item>
                        );
                      })}
                  </DropdownButton>
                </Col>
                <Col xs={6}>
                  <Dropdown className={'config-dropdown-drop'} variant={'secondary'} alignRight>
                    <Dropdown.Toggle id="dropdown-basic" variant="secondary">
                      {currentRole?.translated_name ? currentRole?.translated_name : 'انتخاب نقش'}
                    </Dropdown.Toggle>
                    {roleList ? (
                      <Dropdown.Menu align={'left'}>
                        {roleList &&
                          roleList.map(function(item) {
                            return (
                              <Dropdown.Item key={item.name} onSelect={() => handleSelectRole(item)}>
                                {item.translated_name}
                              </Dropdown.Item>
                            );
                          })}
                      </Dropdown.Menu>
                    ) : (
                      ''
                    )}
                  </Dropdown>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <span>
              بعد از انتخاب سازمان و نقش خود، چنانچه قصد تغییر آنرا داشتید میتوانید از دکمه تغییر نقش در منوی بالای صفحه
              استفاده نمایید.
            </span>
            <Button variant="primary" onClick={handleClose}>
              ثبت
            </Button>
          </Modal.Footer>
        </Modal>
      </div>

      <Dropdown className="kt-header__topbar-item kt-header__topbar-item--user" drop="down" alignRight>
        <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-user-profile">
          <div className="kt-header__topbar-user">
            {showHi && (
              <>
                <span className="kt-header__topbar-welcome kt-hidden-mobile">سلام</span>
                <span className="kt-header__topbar-username kt-hidden-mobile">{userInfo.username}</span>
              </>
            )}

            {showAvatar && <img alt="Pic" src={`${toAbsoluteUrl('/media/users/avatar.jpg')}`} />}

            {showBadge && (
              <span className="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">
                {/* TODO: Should get from currentUser */}
                {userInfo.username}
              </span>
            )}
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
          {/** ClassName should be 'dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
          <div
            className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
            style={{
              backgroundImage: `url(${toAbsoluteUrl('/media/misc/bg-1.jpg')})`,
            }}
          >
            <div className="kt-user-card__avatar">
              <img alt="Pic" className="kt-hidden" src={`${toAbsoluteUrl('/media/users/avatar.jpg')}`} />
            </div>
            <div className="kt-user-card__name">{userInfo.username}</div>
            <div className="kt-user-card__badge">
              <Button onClick={logoutClickHandler} className="btn btn-light btn-sm btn-bold btn-font-md">
                <i className="fas fa-sign-out-alt" />
                خروج
              </Button>
            </div>
          </div>
          {/*<div className="kt-notification" style={{ background: '#f1f1f1' }}>*/}
          {/*  {selectedRole?.name === permissionTypes.instructor && (*/}
          {/*    <Link to={'/me'}>*/}
          {/*      <span className="kt-notification__item">*/}
          {/*        <div className="kt-notification__item-icon">*/}
          {/*          <i className="flaticon2-calendar-3 kt-font-success" />*/}
          {/*        </div>*/}
          {/*        <div className="kt-notification__item-details">*/}
          {/*          <div className="kt-notification__item-title kt-font-bold"> صفحه استاد</div>*/}
          {/*          <div className="kt-notification__item-time">اطلاعات خود را مشاهده کنید</div>*/}
          {/*        </div>*/}
          {/*      </span>*/}
          {/*    </Link>*/}
          {/*  )}*/}
          {/*</div>*/}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default UserProfile;
